import LoginStatus from "./LoginStatus";

const LoginView = ({loginState, authMethod, setAuthMethod}) => {
  // The code screen must fit above a phone keyboard (which overlays, not
  // resizes, the page), or the Verify button gets buried. Tighten the
  // header and drop the subtitle on mobile there -- the user read it on
  // the screen before. Desktop (md:) keeps the full header.
  const compact = loginState.state === "otp_verify";
  return (
    <>
      <img
        src="./images/ccx_logo.png"
        className={`w-[150px] md:mt-0 md:mb-12 ${compact ? "mt-2 mb-4" : "mt-4 mb-8"}`}
        alt="Logo"
      />
      <div className="text-center w-full mb-4 md:mb-8">
        <h1 className="text-[#191919] text-[25px] md:text-3xl font-semibold mb-1 flex items-center justify-center gap-2">
          <span className="text-[25px] md:text-3xl">
            {loginState.state === "complete_signup"
              ? "You're almost there"
              : "Idaho E&T Job Training"}
          </span>
        </h1>
        <p
          className={`text-[#191919]/80 md:text-lg max-w-xl mx-auto ${compact ? "hidden md:block" : ""}`}
        >
          Watch job training videos to meet Idaho's work requirements and keep
          your SNAP or TAFI benefits.
        </p>
        {loginState.state === "login" && (
          <div className="mt-5 inline-flex rounded-full bg-gray-100 p-1">
            <button
              type="button"
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                authMethod === "phone"
                  ? "bg-black text-white"
                  : "text-gray-600 hover:text-black"
              }`}
              onClick={() => setAuthMethod("phone")}
            >
              Phone
            </button>
            <button
              type="button"
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${
                authMethod === "email"
                  ? "bg-black text-white"
                  : "text-gray-600 hover:text-black"
              }`}
              onClick={() => setAuthMethod("email")}
            >
              Email
            </button>
          </div>
        )}
      </div>
      <LoginStatus {...{loginState}} />
    </>
  );
};

export default LoginView;
